// extracted by mini-css-extract-plugin
export var createdDate = "_lb-1";
export var divider = "_lb-2";
export var headerDivider = "_lb-3";
export var messagesCard = "_lb-0";
export var messagesContainer = "_lb-7";
export var messagesContainerWrapper = "_lb-4";
export var pointerCapturingButtonBoxes = "_lb-a";
export var showLeftPanelButton = "_lb-9";
export var showMoreButton = "_lb-c";
export var showMoreButtonContainer = "_lb-b";
export var summaryTitle = "_lb-6";
export var systemMessageCardWrapper = "_lb-d";
export var topButtons = "_lb-8";
export var withPadding = "_lb-5";